export const TYPEOF_UNDEFINED = 'undefined'; // When the operand's value is undefined.
export const TYPEOF_OBJECT = 'object'; // For values that are objects, arrays, or null.
export const TYPEOF_BOOLEAN = 'boolean'; // When the operand's value is a boolean.
export const TYPEOF_NUMBER = 'number'; // For values that are numbers.
export const TYPEOF_BIGINT = 'bigint'; // For values that are big integers.
export const TYPEOF_STRING = 'string'; // When the operand's value is a string.
export const TYPEOF_SYMBOL = 'symbol'; // For values that are symbols.
export const TYPEOF_FUNCTION = 'function'; // When the operand's value is a function.
export const TRUE = 'true';
